import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPigletManureAdditive, setFootprintingPigletManureAdditiveAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_MANURE_ADDITIVE } from "consts";

import { FootprintingPigletManureAdditivePayload } from "models";

export const useMutateFootprintingPigletManureAdditive = (
  farmId: string,
  year: number,
  payload: FootprintingPigletManureAdditivePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PIGLET_MANURE_ADDITIVE, primaryDataId, isAdmin],
      mutationFn: () =>
        isAdmin ? setFootprintingPigletManureAdditiveAdmin(payload, primaryDataId) : setFootprintingPigletManureAdditive(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PIGLET_MANURE_ADDITIVE, primaryDataId, isAdmin],
          ...footprintingPigletPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
